export class Tab {
  label: string;
  template: string;
  disabled: boolean;

  constructor(label: string, template: string, disabled?: boolean) {
    this.label = label;
    this.template = template;
    this.disabled = disabled ?? false;
  }
}
